import Model from '../../common/model/model';

export type AlternativeStatus = 'correct' | 'incorrect' | 'empty';

export interface AlternativeRaw {
  index: number;
  answer: string;
  verifier: string;
  status: AlternativeStatus;
  id: number;
}

export default class Alternative extends Model<AlternativeRaw> {
  public getLetter() {
    return String.fromCharCode(65 + this.raw.index);
  }

  public getAnswer() {
    return this.raw.answer;
  }

  public getStatus() {
    return this.raw.status;
  }

  public getVerifier() {
    return this.raw.verifier;
  }

  public getIndex() {
    return this.raw.index;
  }

  public setStatus(status: AlternativeStatus) {
    this.raw.status = status;
  }

  public setIndex(index: number) {
    this.raw.index = index;
  }
}
